export default "__VITE_ASSET__DURrCEYL__"